import { config } from 'api';

import { computeUserNavigationLinks } from 'apps/root/actions/root';

const computeLinks = (nextState, replace, path, extras) => {
  const { store } = extras;
  if (config.isServer) {
    return store.dispatch(computeUserNavigationLinks());
  }
  return true;
};

export default computeLinks;
